import { federatedSignIn } from '../utils/amplifyAuthHelpers';
import React, { useState } from 'react';
import { Button } from '../ui/button';

const AuthDropdown = ({ headers }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  return (
    <div>
      <Button
        type='button'
        size='lg'
        onClick={toggleDropdown}
        style={{ fontFamily: headers, color: 'white', width: '100%' }}>
        Sign In with Partner
      </Button>
      {showDropdown && (
        <div
          style={{
            backgroundColor: 'none',
            position: 'absolute',
            top: '100%',
            left: '0',
            width: '100%',
            boxShadow: '0px 8px 16px 0px rgba(0, 0, 0, 0.2)',
          }}>
          <button
            type='button'
            className='w-full rounded-lg bg-primary px-4 py-3 text-primary-foreground font-semibold xero-login partner-btn'
            style={{ fontFamily: headers, width: '100%' }}
            onClick={() => federatedSignIn({ customProvider: 'Xero' })}>
            Sign in with{' '}
            <img
              src={process.env.PUBLIC_URL + '/images/xero_circle.png'}
              alt='Xero logo'
              style={{ width: '40px', height: '40px' }}
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default AuthDropdown;
